export default __webpack_public_path__ + "17e5144850cea9b80672034e885928f9.png";